import { IPaths } from "~/types/routing";

export const paths: IPaths = {
  home: "/",
  cancel: "/cancel",
};
